module.exports = __webpack_public_path__ + "img/3.ab3ffd63.png";